import { ReactNode } from 'react'
import PostAnnounce from 'modules/community/components/post-announce/post-announce'
import { PostCommentsInfoInterface } from 'modules/community/types/post-info'
import { PostInterface } from 'modules/community/types/post-interface'

interface PostAnnouncePinnedProps {
  post: PostInterface
  deletePost: () => Promise<void>
  deletePostAndBanUser: (removeRecentActivitiesChecked: boolean) => Promise<void>
  handleLikeClick?: () => void
  commentsInfo?: PostCommentsInfoInterface[]
  commentsInfoError?: Error | null
}

export const PostPinned = ({
  post,
  deletePost,
  deletePostAndBanUser,
  handleLikeClick,
  commentsInfo,
  commentsInfoError,
}: PostAnnouncePinnedProps): ReactNode => {
  return (
    <PostAnnounce
      isPinnedPost={true}
      post={post}
      key={post.id}
      deletePost={deletePost}
      deletePostAndBanUser={deletePostAndBanUser}
      handleLikeClick={handleLikeClick}
      commentsInfo={commentsInfo}
      commentsInfoError={commentsInfoError}
    />
  )
}
